import type { TRuleWithTheme } from 'styles/theme';
import type { TRule } from 'fela';

export const title: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.textSecondary,
    marginBottom: '0.5rem',
    fontSize: '0.75rem',
    fontWeight: 500,
});

export const value: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.text,
    display: 'flex',
    alignItems: 'center',
    lineHeight: '1.5rem',
    fontSize: '1rem',

    fontWeight: 500,

    '& .anticon': {
        color: `${theme.colors.textSecondary} !important`,
    },
});
export const company: TRuleWithTheme = ({ theme }) => ({
    maxWidth: '12.5rem',
});

export const container: TRule = () => ({
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '1.25rem',
    paddingTop: '0.88rem',
    paddingBottom: '0.88rem',
    minHeight: '10.44rem',
    ':last-of-type': {
        marginBottom: 0,
    },
    '&:hover': {
        cursor: 'auto',
    },
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
    color: '#262626',
    background: '#fff',
    borderRadius: '2px',
});
export const subStatus: TRule = () => ({
    display: 'flex',
    flexDirection: 'row',
});
export const subStatusChange: TRule = () => ({
    marginLeft: '0.5rem',
    '& .ant-space-item': {
        textDecoration: 'underline',
    },
});
export const row: TRule = () => ({
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    paddingBottom: '3.13rem',
});
export const rowtop: TRule = () => ({
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    paddingBottom: '6.13rem',
});
export const rowBottom: TRule = () => ({
    display: 'flex',
    flexDirection: 'row',
    paddingTop: '1.5rem',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
});
export const divider: TRule = () => ({
    borderTop: 'solid 1px #EBEBEB',
});
export const topSelect: TRule = () => ({
    marginBottom: '1rem',
    paddingLeft: '1.5rem',
});

export const menu: TRule = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: 0,
    margin: 0,

    ':hover': {
        background: 'none',
    },
    ':active': {
        background: 'none',
    },
    ':focus': {
        background: 'none',
    },
    '& .anticon': {
        marginRight: '1.25em',
    },
});
export const cell: TRule = () => ({
    // width: '148px',
    marginRight: '2rem',
});

export const factoryNumber: TRule = () => ({
    textDecorationLine: 'underline',
    textDecorationThickness: '0.1rem',
    ':hover': {
        color: '#f57645',
    },
});
